import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface SplashScreenProps {
  onComplete: () => void;
}
const BACKGROUND_URL = 'https://cdn.magicpatterns.com/uploads/5mBmRSKUHLpmNHoh2onnAq/image.png';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/k5mzauqmFki77bNt7CFYh1/Whatsapp_digiBOP-removebg-preview.png';
export function SplashScreen({
  onComplete
}: SplashScreenProps) {
  useEffect(() => {
    const t = setTimeout(() => onComplete(), 3000);
    return () => clearTimeout(t);
  }, [onComplete]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.4
  }} className="w-full min-h-screen relative overflow-hidden" data-id="element-3244">
      {/* Background — edge-to-edge */}
      <img src={BACKGROUND_URL} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover select-none pointer-events-none" draggable={false} data-id="element-3245" />

      {/* Logo cluster — centered, slightly above vertical center (~40% from top) */}
      <div className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center" style={{
      top: '40%',
      transform: 'translate(-50%, -50%)',
      width: 240,
      height: 240,
      zIndex: 2
    }} data-id="element-3246">
        {/* Ripple rings — behind the logo */}
        <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
        zIndex: 1
      }} data-id="element-3247">
          {[0, 0.8, 1.6].map((delay, i) => <motion.span key={i} className="absolute inset-0 rounded-full" style={{
          border: '1.5px solid rgba(243,112,36,0.35)',
          background: 'radial-gradient(circle, rgba(243,112,36,0.08) 0%, rgba(243,112,36,0) 70%)'
        }} initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1.7,
          opacity: [0, 0.7, 0]
        }} transition={{
          duration: 2.8,
          repeat: Infinity,
          delay,
          ease: 'easeOut'
        }} data-id="element-3248" />)}
        </div>

        {/* Logo */}
        <motion.img src={LOGO_URL} alt="digiBOP" className="relative select-none pointer-events-none" style={{
        width: 150,
        height: 'auto',
        zIndex: 3
      }} initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} draggable={false} data-id="element-3249" />
      </div>

      {/* Tagline — centered below logo */}
      <motion.div className="absolute left-0 right-0 text-center" style={{
      top: 'calc(40% + 130px)',
      fontFamily: 'Poppins, system-ui, sans-serif',
      fontWeight: 600,
      fontSize: 13,
      letterSpacing: '0.18em',
      color: '#7A2E10',
      zIndex: 3
    }} initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.25
    }} data-id="element-3250">
        SIMPLE . SPEEDY . SECURE
      </motion.div>

      {/* Gradient loader bar — directly below tagline */}
      <div className="absolute left-1/2" style={{
      top: 'calc(40% + 130px + 16px + 18px)',
      transform: 'translateX(-50%)',
      width: 100,
      height: 2,
      borderRadius: 2,
      overflow: 'hidden',
      background: 'linear-gradient(90deg, rgba(102,24,6,0.15) 0%, rgba(243,112,36,0.15) 100%)',
      zIndex: 3
    }} aria-hidden data-id="element-3251">
        {/* Base gradient track */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(90deg, #661806 0%, #F37024 100%)',
        opacity: 0.4
      }} data-id="element-3252" />
        {/* Animated shimmer sweep */}
        <motion.div className="absolute top-0 bottom-0" style={{
        width: '40%',
        background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0) 100%)',
        mixBlendMode: 'overlay'
      }} initial={{
        x: '-50%'
      }} animate={{
        x: '250%'
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-3253" />
        {/* Solid gradient bar that sweeps fill across */}
        <motion.div className="absolute top-0 bottom-0 left-0" style={{
        borderRadius: 2,
        background: 'linear-gradient(90deg, #661806 0%, #F37024 100%)'
      }} initial={{
        width: '0%'
      }} animate={{
        width: ['0%', '100%', '100%', '0%']
      }} transition={{
        duration: 2.2,
        times: [0, 0.55, 0.65, 1],
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-3254" />
      </div>

      {/* Footer */}
      <div className="absolute left-0 right-0 text-center" style={{
      bottom: 24,
      fontFamily: 'Poppins, system-ui, sans-serif',
      fontWeight: 300,
      fontSize: 11,
      color: '#8C6A5A',
      zIndex: 3
    }} data-id="element-3255">
        Encrypted and Secured | Version 2.0
      </div>
    </motion.div>;
}